
import React, { Component,useRef } from 'react';
import axios from 'axios';
import { Tabs,Tab } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import moment from 'moment';
import { ApiConstants } from './ApiConstants';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { HashRouter as Router,hashHistory, Route, Link } from 'react-router-dom'
import Helmet from 'react-helmet';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';


import 'moment/locale/en-in';
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
const { SearchBar, ClearSearchButton } = Search;
var context;
const { ExportCSVButton } = CSVExport;


export default class SalesReport extends Component
{
  constructor(props) {
    super(props);
    this.handleFromChange = this.handleFromChange.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.state = {
      // default to the current month (1st -> today) so reports are usable immediately; user can still change
      from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      to: new Date(),
      loading:true,
      Centers:[],
      dataDiv:[],
      dateArraytableItem:[],
      CenterId:"",
      headerDiv:[],
      Total_transactions: [],
      Total_transactions_Sales:[],
      supply_date:formatDate(new Date(), 'DD-MM-YYYY'),
      Item:[],
      Itemvalue:0,
      dateArraytable:[],
      Vendor:[],
      dataDivPayments:[],
      valueVendor:0,
      Itemvaluesupply:0,
      // ---- Report 1 (Payments) & Report 2 (Monthly Statement) ----
      paymentGroupBy:'date',
      paymentsReportData:[],
      incentiveReportData:[],
      statementAxis:'centre',
      monthlyStatementData:[],
      AllVendors:[],
      salesReportData:[],
      salesReportModes:[]

    };
    context=this

    //alert(this.props.VendorId)
  }
  logout()
  {
    localStorage.clear();
        window.location='/login'
  }
  getCurrentDate(separator=''){

    let newDate = new Date()
    let date = newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    
    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
    }
  showFromMonth() {
    const { from, to } = this.state;

    
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), 'months') < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  }
  VendorbyCenter(CenterId)
  {
    this.setState({loading:false})

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    
    myHeaders.append("Origin", "application/x-www-form-urlencoded");

   
     var urlencoded = new URLSearchParams();
    urlencoded.append("CenterId",CenterId);
    urlencoded.append("Billing_date_mode", "2");
    var VENDOR = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };

    fetch(ApiConstants.VIEWVENDOR, VENDOR)
    .then(dataWrappedByPromise => dataWrappedByPromise.json())
      .then(response => 
              {


                var centerdata= response.data;

                var Vendor = centerdata.map(function (data) {
      
                  return {
                    Location: data.Location,
                    Name:  data.Name,
                    Address:data.Address,
                    id:  data.id,
                    updated_dt:data.updated_dt,
                    Center_name: data.Center_name,
      
                    DateOfJoin: data.DateOfJoin,
      
                    ContactPerson: data.ContactPerson,
                    ContactNumber: data.ContactNumber,
                   
                    
                    edit:'View more'
                  }
                })
       


          //alert(response.message)
this.setState({
  Vendor:Vendor,loading:true
})
  
        }
        
        )
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); this.setState({ loading: true }); });
    
  }
  componentDidMount()
  {
    this.setState({loading:false})

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    
    myHeaders.append("Origin", "application/x-www-form-urlencoded");

   
  
    var Center = {
      method: 'GET',
      redirect: 'follow',
      headers: myHeaders,
    };
 
          fetch(ApiConstants.VIEWCENTER_Item_Vendor, Center)
          .then(dataWrappedByPromise => dataWrappedByPromise.json())
            .then(Centersresponse => 
              
              {


               


          //alert(response.message)
this.setState({
//  from: formatDate(new Date().setDate(new Date().getDate()-30), 'DD-MM-YYYY'),
//  to:formatDate(new Date(), 'DD-MM-YYYY'),
  Centers:Centersresponse.Center,

  Item:Centersresponse.Item,
  AllVendors:Centersresponse.Vendor,
  loading:true
})
  
        }
        
        )
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); this.setState({ loading: true }); });
    
  }
  
  GetDatawillallsupply(CenterId,from,to,VendorId) {
    

    this.setState({ loading: false,Total_transactions:[] })
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Origin", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("Billing_date_mode", "2");
        urlencoded.append("VendorId",VendorId);
        urlencoded.append("CenterId",CenterId);
        urlencoded.append("from",formatDate(new Date(from), 'DD-MM-YYYY'))
        urlencoded.append("to",formatDate(new Date(to), 'DD-MM-YYYY'));
        urlencoded.append("Selling_Day", formatDate(new Date(), 'dddd'));
      //  alert(supply_date)
         
   
        // console.log(CenterId)
        // console.log(supply_date)
        var GETSALESBILLING = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        
        fetch(ApiConstants.GETSALESBILLING, GETSALESBILLING)
        .then(dataWrappedByPromise => dataWrappedByPromise.json())
        .then(CETERBOOKRES => {
        

          var urlencoded = new URLSearchParams();
          urlencoded.append("CenterID",this.state.CenterId);
          var VendorbyCenters = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
          };
   
          fetch(ApiConstants.VENDORSBYCENTER, VendorbyCenters)
          .then(dataWrappedByPromise => dataWrappedByPromise.json())
          .then(VendorbyCenter => {
          
     let Vendor=VendorbyCenter.response



       
           let to=CETERBOOKRES[(CETERBOOKRES.length)-2].supply_date

           let from=CETERBOOKRES[0].supply_date
  

let items=[]


let Total_transactions=[];

Total_transactions=CETERBOOKRES[0].All_JSON_Date

if(typeof Total_transactions === 'string')
{
Total_transactions=Total_transactions.toString().replace('\\', '')
Total_transactions=JSON.parse(Total_transactions)
}




for(let k=0; k<Vendor.length; k++)
{

if(Vendor[k].id==VendorId)
{
  // items=Total_transactions[k].Fld1;


  items=typeof Vendor[k].Fld1 === 'string' ? JSON.parse(Vendor[k].Fld1) : Vendor[k].Fld1
}
}

if(items==undefined)
{
  items=CETERBOOKRES[(CETERBOOKRES.length)-1]
if(typeof items === 'string')
{
items=items.toString().replace('\\', '')
items=JSON.parse(items)
}
items=items.items;
 
}

let columns = []
let j=0;
columns[j]={
  dataField: 'Date',
  text: 'Date',
  sort: true,
  style: (cell, row, rowIndex, colIndex) => {
    return { width: "100px" };
  }
}
j=j+1;
columns[j]={
  dataField: 'Day',
  text: 'Day',
  sort: true,
  style: (cell, row, rowIndex, colIndex) => {
    return { width: "100px" };
  }
}
for(let i=0; i<items.length; i++)
{

 j=j+1;
  columns[j]={
    dataField: items[i].FormalName,
    text: items[i].FormalName,
    sort: true
  }

 
}
j=j+1;
columns[j]={
  dataField: 'Total',
  text: 'Total',
  sort: true
}
//console.log(columns)
this.setState({items:items,columns:columns})

let products=[]
let Total_transactions_Return=[]
let ar=0;
         // alert(CETERBOOKRES.TotalCenter[0].TotalCenter)
         for(let z=0; z<CETERBOOKRES.length; z++)
         {
if(CETERBOOKRES[z].All_JSON_Date!=undefined)
{
          let Total_transactions=[];

            Total_transactions=CETERBOOKRES[z].All_JSON_Date

         if(typeof Total_transactions === 'string')
         {
         Total_transactions=Total_transactions.toString().replace('\\', '')
          Total_transactions=JSON.parse(Total_transactions)
         }
       
       


          for(let k=0; k<Total_transactions.length; k++)
          {
          
if(Total_transactions[k].Vendor_Code==VendorId)
{

let itm=[];
let retn=[];
let Amount=0;
let AmountRtn=0;
           for(let m=0; m<Total_transactions[k].transaction.length; m++)
           {
     
           // Return amount: no ReturnTotal in data, so derive unit price = line Total / Supply_Copies, then x Return_Copies
           {
             let __tx=Total_transactions[k].transaction[m];
             let __sup=parseFloat(__tx.Supply_Copies!=undefined?__tx.Supply_Copies.toString():'0');
             let __rtn=parseFloat(__tx.Return_Copies!=undefined?__tx.Return_Copies.toString():'0');
             let __tot=parseFloat(__tx.Total!=undefined?__tx.Total.toString().replace('Rs.',''):'0');
             if(isNaN(__sup)){__sup=0;} if(isNaN(__rtn)){__rtn=0;} if(isNaN(__tot)){__tot=0;}
             Amount=Amount+__tot;
             let __unit=(__sup>0)?(__tot/__sup):0;
             AmountRtn=AmountRtn+(__unit*__rtn);
           }
               if(m==0)
           {
            itm='"'+[Total_transactions[k].transaction[m].Item]+'":"'+ Total_transactions[k].transaction[m].Supply_Copies+'"'
            retn='"'+[Total_transactions[k].transaction[m].Item]+'":"'+ Total_transactions[k].transaction[m].Return_Copies+'"'
         
         
            
          }else{
            itm=itm+',"'+[Total_transactions[k].transaction[m].Item]+'":"'+  Total_transactions[k].transaction[m].Supply_Copies.toString()+'"'
            retn=retn+',"'+[Total_transactions[k].transaction[m].Item]+'":"'+  Total_transactions[k].transaction[m].Return_Copies.toString()+'"'
           
           }

            
        //    Total_transactions[k].transaction.push(transaction[m])
          
           }
//console.log(itm)



let tempitem=[]
let temparry={
  Date: CETERBOOKRES[z].supply_date,
   Total:Amount,
 
  
 }
 let temparryRtn={
  Date: CETERBOOKRES[z].supply_date,
   Total:AmountRtn,


 }



 itm=itm+',"Date":"'+CETERBOOKRES[z].supply_date+'","Day":"'+formatDate(new Date(  CETERBOOKRES[z].supply_date.toString().split('-')[1]+"/"+CETERBOOKRES[z].supply_date.toString().split('-')[0]+"/"+CETERBOOKRES[z].supply_date.toString().split('-')[2]), 'dddd')+'","Total":"'+parseFloat(Amount).toFixed(2)+'"';


 retn=retn+',"Date":"'+CETERBOOKRES[z].supply_date+'","Day":"'+formatDate(new Date(  CETERBOOKRES[z].supply_date.toString().split('-')[1]+"/"+CETERBOOKRES[z].supply_date.toString().split('-')[0]+"/"+CETERBOOKRES[z].supply_date.toString().split('-')[2]), 'dddd') +'","Total":"'+parseFloat(AmountRtn).toFixed(2)+'"';
 tempitem=itm
//  for(let it=1; it>=itm.split(',').length; it++)
//  {
//   temparry.push()
//  }

//console.log(tempitem)
temparry= '{'+tempitem+'}'
temparryRtn= '{'+retn+'}'
//temparry.push(tempitem)
//console.log(temparry)
        
products.push(JSON.parse(temparry))
Total_transactions_Return.push(JSON.parse(temparryRtn))
ar=ar+Amount

        
}

       
          }
        }
      }
       
      
        this.setState({ loading: true,products:products,  TotalAmout:ar, Total_transactions_Sales:products, Total_transactions_Return:Total_transactions_Return })


                
       
        })
  

      })
    
      .then(result => console.log(result))
      .catch(error =>{ console.log('error', error); this.setState({loading:true, })});

  }
  GetallData= (event) => 
    {
     // alert(event.target.value)
      this.setState({
        VendorId:event.target.value,
        VendorName:event.target.options[event.target.selectedIndex].text
      })
      
      //this.GetDatabyVendor(this.state.CenterId,this.state.supply_date,event.target.value); 

//alert(event.target.value)
      // this.setState({ to }, this.showFromMonth);
      // var d = new Date(to);
         
      // this.savetojson()
      if(event.target.value==0)
      {
       this.GetData(this.state.CenterId, formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
      }
      if(event.target.value==1)
      {
       this.GetDataALLCenter(formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
      }

      else{
        this.GetData(this.state.CenterId, formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
     
      }
       

    }

  handleFromChange(from) {
    // Change the from date and focus the "to" input field
    this.setState({ from });


  }

  handleToChange(to) {
 
    this.setState({ to }, this.showFromMonth);
   var d = new Date(to);
  //  let from=formatDate(new Date().setDate(new Date().getDate()-30), 'MMMM Do YYYY');
  //  if(this.state.from==undefined)
  //  {   this.setState({
  //     from:from
  //   })
  // }
   // this.savetojson()
    
    // if(this.state.CenterId==1)
    //   {
    //    this.GetDataALLCenter(formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(to), 'DD-MM-YYYY'));
    //   }else if(this.state.CenterId==0){
    //     this.GetData(this.state.CenterId, formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(to), 'DD-MM-YYYY'));

    //   }else{
    //     this.GetData(this.state.CenterId, formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(to), 'DD-MM-YYYY'));

    //   }


    this.setState({
      
      value:0,
      Itemvalue:0,
      dateArraytable:[],
      valueVendor:0,
      headerDiv:[], dataDiv:[],VendorId:0,Total_transactions:[],dataDivPayments:[]
    })
  }

  
  handleChange = (event) => {
    console.log(event.target.value)
  
    this.setState({
      Centername:event.target.options[event.target.selectedIndex].text,
      CenterId:event.target.value,
      value:event.target.value,
    })
    if(event.target.value==0)
    {
       }
    if(event.target.value==1)
    {
     this.GetDataALLCenter(formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
    }

    else{
      this.GetData(event.target.value, formatDate(new Date(this.state.from), 'DD-MM-YYYY'), formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
    }


  };



  GetData(CenterId,from,to) {
    
if(CenterId=="")
{
  CenterId=0
}

    this.setState({ loading: false,Total_transactions:[] })
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Origin", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
     
        urlencoded.append("CenterId",CenterId);
        urlencoded.append("from",from);
        urlencoded.append("to",to);
        urlencoded.append("Selling_Day", formatDate(new Date(), 'dddd'));
      //  alert(supply_date)
         
   
        // console.log(CenterId)
        // console.log(supply_date)
        var GETSALESBILLING = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        
        fetch(ApiConstants.GETSALEFORREPORT, GETSALESBILLING)
        .then(dataWrappedByPromise => dataWrappedByPromise.json())
        .then(CETERBOOKRES => 
          {
            this.setState({
              Item:CETERBOOKRES.Item
            })
            let allcenterdata=[];
            let CenterBookdata=[];
            


            const headerDiv=[];
            const dataDiv=[];
        

            var dateArray = [];

            from=from.split('-')[2]+'-'+from.split('-')[1]+'-'+from.split('-')[0];
            to=to.split('-')[2]+'-'+to.split('-')[1]+'-'+to.split('-')[0];
            var currentDate = moment(from);
            var stopDate = moment(to);

           
            while (currentDate <= stopDate) {
                dateArray.push( moment(currentDate).format('DD-MM-YYYY') )
                currentDate = moment(currentDate).add(1, 'days');
            }
            console.log(dateArray)
      let SupplyCenter=CETERBOOKRES.SupplyCenter;
      dateArray.map(function(dates)
      {
      for(let k=0; k<CETERBOOKRES.CenterBook.length; k++)
      {
        let CenterBookdataobj={};

            let supply_date=CETERBOOKRES.CenterBook[k].supply_date;
            let CenterBook;
            if (CETERBOOKRES.CenterBook[k].__parsed !== undefined) { CenterBook = CETERBOOKRES.CenterBook[k].__parsed; }
            else {
            CenterBook = CETERBOOKRES.CenterBook[k].All_JSON_Date
            if(typeof CenterBook !== 'string'){ CenterBook = JSON.stringify(CenterBook) }
           CenterBook = CenterBook.replace(/\\n/g, "\\n")  
            .replace(/\\'/g, "\\'")
            .replace(/\\"/g, '\\"')
            .replace(/\\&/g, "\\&")
            .replace(/\\r/g, "\\r")
            .replace(/\\t/g, "\\t")
            .replace(/\\b/g, "\\b")
            .replace(/\\f/g, "\\f");
      // remove non-printable and other non-valid JSON chars
      CenterBook = CenterBook.replace(/[\u0000-\u0019]+/g,""); 
      
      CenterBook = JSON.parse(CenterBook);
            if (!Array.isArray(CenterBook)) { CenterBook = []; }
            CETERBOOKRES.CenterBook[k].__parsed = CenterBook;
            }



    
        if(supply_date==dates)
        {  
          let arr=[];

          let itemobjTotal={}
          let Total_Supply_Copies=0;
          let Total_Return_Copies=0;
let Total_TotalSuppy=0;
let Total_UnsoldCopies=0;
          itemobjTotal["ITEM"]="Total"
          itemobjTotal["CODE"]="0"
          CETERBOOKRES.Item.map(function(alldata)
          {

             let Supply_Copies=0;
            let Return_Copies=0;
              let itemobj={}
            CenterBook.map(function (CenterBook)
            {  
        
              CenterBook.transaction.map(function (transaction)
              {
                if(alldata.id==transaction.id)
                          {
                {
                  if(isNaN(parseFloat(transaction.Supply_Copies))==false)
                  {
                     Supply_Copies=Supply_Copies+parseFloat(transaction.Supply_Copies)
                  }
                  if(isNaN(parseFloat(transaction.Return_Copies))==false)
                  {
                     Return_Copies=Return_Copies+parseFloat(transaction.Return_Copies)
                   }
                 }
                }

            
          })
          itemobj["SALE"]=Supply_Copies
          itemobj["RTN"]=Return_Copies
          itemobj["DATE"]=dates
         let week=dates.split('-')[2]+'-'+dates.split('-')[1]+'-'+dates.split('-')[0];
          itemobj["WEEK"]=moment(week).format('ddd')
          itemobj["ITEM"]=alldata.FormalName
          itemobj["CODE"]=alldata.id


          
          })


          Total_Supply_Copies=Total_Supply_Copies+parseFloat(Supply_Copies)
          Total_Return_Copies=Total_Return_Copies+parseFloat(Return_Copies)
          SupplyCenter.map(function(SupplyCenter)
          {
     
            if(SupplyCenter.Supply_date==dates)
            { 
             
            if(SupplyCenter.ItemId==alldata.id)
            {
            
              itemobj["SUP"]=SupplyCenter.TotalSuppy
              itemobj["US"]=SupplyCenter.UnsoldCopies

              let __sc=parseFloat(SupplyCenter.TotalSuppy); if(isNaN(__sc)){__sc=0}
              let __uc=parseFloat(SupplyCenter.UnsoldCopies); if(isNaN(__uc)){__uc=0}
              Total_TotalSuppy=Total_TotalSuppy+__sc
              Total_UnsoldCopies=Total_UnsoldCopies+__uc
            }
          }

          })
          itemobjTotal["SALE"]=Total_Supply_Copies
          itemobjTotal["RTN"]=Total_Return_Copies
          itemobjTotal["SUP"]=Total_TotalSuppy
          itemobjTotal["US"]=Total_UnsoldCopies


          
          arr.push(itemobj)
        //  arr.push(itemobjTotal)
          
          })
          arr.push(itemobjTotal)
          CenterBookdata.push(arr)

      

        
      
        }
      
    }



    })



{
  CETERBOOKRES.Item.push(

{
  FormalName: "Total",
NonSalesDays: "",
Price: "0"

}

  )
}

headerDiv.push(
  <td style={{textAlign:'center',borderRight:'1px solid #CCC', width:150}}>DATE</td>    )
  headerDiv.push(
    <td style={{textAlign:'center',borderRight:'1px solid #CCC', width:80}}>DAY</td>      )



    for(let m=0; m<CETERBOOKRES.Item.length; m++)
    {
      

      headerDiv.push(
        <td>
        <table style={{textAlign:'center', color:'#ffffff', }}>
        
        <tr style={{textAlign:'center',borderBottom:'1px solid #CCC',borderRight:'1px solid #CCC' }}>
        
        <td  colspan="4">{ CETERBOOKRES.Item[m].FormalName}</td>
        
        </tr>
        <tr>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>SUP</td>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>US</td>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>RTN</td>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>SALE</td>
        </tr>
        </table>
        </td>
)
      }

let alldivs=[];
dataDiv.push(   <tr>{headerDiv}</tr>)
      
    CenterBookdata.map(function(data)
    {

let dataDivs=[];

dataDivs.push(
<td style={{textAlign:'center',borderRight:'1px solid #CCC', width:150}}>{data[0].DATE}</td>
)
dataDivs.push(
<td style={{textAlign:'center',borderRight:'1px solid #CCC', width:80}}>{data[0].WEEK}</td>
)
      data.map(function (innerdata)
      {



        dataDivs.push(
          
          <td>
          <table style={{textAlign:'center',  color:'#ffffff',}}>
         
          <tr>
          <td style={{textAlign:'center', color:'#ffffff', width:30,borderRight:'1px solid #CCC'}}>{innerdata.SUP}</td>
          <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>{innerdata.US}</td>
          <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>{innerdata.RTN}</td>
          <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>{innerdata.SALE}</td>
          </tr>
          </table>
          </td>
  )

    
      })

      dataDiv.push(   <tr style={{borderTop:'1px solid #ccc'}}>{dataDivs}</tr>)
      

    }
    
    )



this.setState({headerDiv:headerDiv, dataDiv:dataDiv,loading:true})

    
    
      
          })
  


    
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); this.setState({ loading: true }); });

  }
  GetDataALLCenter(from,to) {
    


    
    this.setState({ loading: false,Total_transactions:[] })
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Origin", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("CenterId",this.state.CenterId);
        urlencoded.append("from",from);
        urlencoded.append("to",to);
        urlencoded.append("Selling_Day", formatDate(new Date(), 'dddd'));
      //  alert(supply_date)
         
   
        // console.log(CenterId)
        // console.log(supply_date)
        var GETSALESBILLING = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        
        fetch(ApiConstants.GETSALEFORREPORTALLCENTER, GETSALESBILLING)
        .then(dataWrappedByPromise => dataWrappedByPromise.json())
        .then(CETERBOOKRES => 
          {
this.setState({
  Item:CETERBOOKRES.Item
})
            let allcenterdata=[];
            let CenterBookdata=[];
            


            const headerDiv=[];
            const dataDiv=[];
        

            var dateArray = [];

            from=from.split('-')[2]+'-'+from.split('-')[1]+'-'+from.split('-')[0];
            to=to.split('-')[2]+'-'+to.split('-')[1]+'-'+to.split('-')[0];
            var currentDate = moment(from);
            var stopDate = moment(to);

           
            while (currentDate <= stopDate) {
                dateArray.push( moment(currentDate).format('DD-MM-YYYY') )
                currentDate = moment(currentDate).add(1, 'days');
            }
           
      let SupplyCenter=CETERBOOKRES.SupplyCenter;

 
      dateArray.map(function(dates)
      {

       
      for(let k=0; k<CETERBOOKRES.CenterBook.length; k++)
      {
        let CenterBookdataobj={};

            let supply_date=CETERBOOKRES.CenterBook[k].supply_date;
            let CenterBook;
            if (CETERBOOKRES.CenterBook[k].__parsed !== undefined) { CenterBook = CETERBOOKRES.CenterBook[k].__parsed; }
            else {
            CenterBook = CETERBOOKRES.CenterBook[k].All_JSON_Date
            if(typeof CenterBook !== 'string'){ CenterBook = JSON.stringify(CenterBook) }
           CenterBook = CenterBook.replace(/\\n/g, "\\n")  
            .replace(/\\'/g, "\\'")
            .replace(/\\"/g, '\\"')
            .replace(/\\&/g, "\\&")
            .replace(/\\r/g, "\\r")
            .replace(/\\t/g, "\\t")
            .replace(/\\b/g, "\\b")
            .replace(/\\f/g, "\\f");
      // remove non-printable and other non-valid JSON chars
      CenterBook = CenterBook.replace(/[\u0000-\u0019]+/g,""); 
      
      CenterBook = JSON.parse(CenterBook);
            if (!Array.isArray(CenterBook)) { CenterBook = []; }
            CETERBOOKRES.CenterBook[k].__parsed = CenterBook;
            }
    
        if(supply_date==dates)
        {  
          let arr=[];
          
          CETERBOOKRES.Item.map(function(alldata)
          {

            let Supply_Copies=0;
          let Return_Copies=0;
              let itemobj={}
            CenterBook.map(function (CenterBook)
            {  
              let item="";
              CenterBook.transaction.map(function (transaction)
              {
               
                if(alldata.id==transaction.id)
                          {
                         if(isNaN(parseFloat(transaction.Supply_Copies))==false)
                         {
                            Supply_Copies=Supply_Copies+parseFloat(transaction.Supply_Copies)
                         }
                         if(isNaN(parseFloat(transaction.Return_Copies))==false)
                         {
                            Return_Copies=Return_Copies+parseFloat(transaction.Return_Copies)
                          }
                        }
          

            
          })
         
      
        
          itemobj["ITEM"]=alldata.FormalName
          itemobj["CODE"]=alldata.id



          
          })
          itemobj["DATE"]=dates
          let week=dates.split('-')[2]+'-'+dates.split('-')[1]+'-'+dates.split('-')[0];
           itemobj["WEEK"]=moment(week).format('ddd')
          itemobj["SALE"]=Supply_Copies
          itemobj["RTN"]=Return_Copies
          SupplyCenter.map(function(SupplyCenter)
          {
     
            if(SupplyCenter.Supply_date==dates)
            { 
             
            if(SupplyCenter.ItemId==alldata.id)
            {
            
              itemobj["SUP"]=SupplyCenter.TotalSuppy
              itemobj["US"]=SupplyCenter.UnsoldCopies
              
            }
          }

          })
       
          arr.push(itemobj)
          })
          CenterBookdata.push(arr)

      

        
      
        }
      
    }

//     allcenterdata.push(dates)
//     allcenterdata.push(Supply_Copies)
//     allcenterdata.push(Return_Copies)
 
    })
  //  CenterBookdata=JSON.stringify(CenterBookdata)
  //  CenterBookdata=JSON.parse(CenterBookdata)
  //  console.log(CenterBookdata)
var __allCenterAgg = {};
    CenterBookdata.forEach(function (dataAll) {
      dataAll.forEach(function (data) {
        var __k = data.DATE + '|' + data.CODE;
        if (!__allCenterAgg[__k]) __allCenterAgg[__k] = { SALE: 0, RTN: 0, SUP: 0, US: 0 };
        __allCenterAgg[__k].SALE += parseFloat(data.SALE) || 0;
        __allCenterAgg[__k].RTN += parseFloat(data.RTN) || 0;
        __allCenterAgg[__k].SUP += parseFloat(data.SUP) || 0;
        __allCenterAgg[__k].US += parseFloat(data.US) || 0;
      });
    });
    let Alldata=[]
    dateArray.map(function(dates)
      { 
      
          let arr=[];
    
        
          let itemobjTotal={}
  
          itemobjTotal["ITEM"]="Total"
          itemobjTotal["CODE"]="0"

          let Total_Supply_Copies=0;
          let Total_Return_Copies=0;
          let Total_UnsoldCopies=0;
          let Total_TotalSuppy=0;
        CETERBOOKRES.Item.map(function(alldata)
        { 
          let itemobj={}

          itemobj["ITEM"]=alldata.FormalName
          itemobj["CODE"]=alldata.id

       
          let Supply_Copies=0;
          let Return_Copies=0;
          let UnsoldCopies=0;
          let TotalSuppy=0;
          var __a = __allCenterAgg[dates + '|' + alldata.id];
          if (__a) { Supply_Copies = __a.SALE; Return_Copies = __a.RTN; TotalSuppy = __a.SUP; UnsoldCopies = __a.US; }
        itemobj["SALE"]=Supply_Copies
        itemobj["RTN"]=Return_Copies
        itemobj["SUP"]=TotalSuppy
        itemobj["US"]=UnsoldCopies         
        itemobj["DATE"]=dates
        let week=dates.split('-')[2]+'-'+dates.split('-')[1]+'-'+dates.split('-')[0];
        itemobj["WEEK"]=moment(week).format('ddd')       
        arr.push(itemobj)
      
        Total_Supply_Copies=Total_Supply_Copies+Supply_Copies
        Total_Return_Copies=Total_Return_Copies+Return_Copies
        Total_UnsoldCopies=Total_UnsoldCopies+UnsoldCopies
        Total_TotalSuppy=Total_TotalSuppy+TotalSuppy
    })
    

    itemobjTotal["SALE"]=Total_Supply_Copies
    itemobjTotal["RTN"]=Total_Return_Copies
    itemobjTotal["SUP"]=Total_TotalSuppy
    itemobjTotal["US"]=Total_UnsoldCopies         
    itemobjTotal["DATE"]=dates
    let week=dates.split('-')[2]+'-'+dates.split('-')[1]+'-'+dates.split('-')[0];
    itemobjTotal["WEEK"]=moment(week).format('ddd')    
    
    
    arr.push(itemobjTotal)
      Alldata.push(arr)


    })

    CenterBookdata=[];
    console.log(Alldata)
    CenterBookdata=Alldata
   
headerDiv.push(
  <td style={{textAlign:'center',borderRight:'1px solid #CCC', width:150}}>DATE</td>    )
  headerDiv.push(
    <td style={{textAlign:'center',borderRight:'1px solid #CCC', width:80}}>DAY</td>      )

{
  CETERBOOKRES.Item.push(

{
  FormalName: "Total",
NonSalesDays: "",
Price: "0"

}

  )
}

    for(let m=0; m<CETERBOOKRES.Item.length; m++)
    {
      

      headerDiv.push(
        <td>
        <table style={{textAlign:'center', color:'#ffffff', }}>
        
        <tr style={{textAlign:'center',borderBottom:'1px solid #CCC',borderRight:'1px solid #CCC' }}>
        
        <td  colspan="4">{ CETERBOOKRES.Item[m].FormalName}</td>
        
        </tr>
        <tr>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>SUP</td>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>US</td>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>RTN</td>
        <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>SALE</td>
        </tr>
        </table>
        </td>
)
      }

let alldivs=[];
dataDiv.push(   <tr>{headerDiv}</tr>)
      
    CenterBookdata.map(function(data)
    {

let dataDivs=[];

dataDivs.push(
<td style={{textAlign:'center',borderRight:'1px solid #CCC', width:150}}>{data[0].DATE}</td>
)
dataDivs.push(
<td style={{textAlign:'center',borderRight:'1px solid #CCC', width:80}}>{data[0].WEEK}</td>
)
      data.map(function (innerdata)
      {



        dataDivs.push(
          
          <td>
          <table style={{textAlign:'center',  color:'#ffffff',}}>
         
          <tr>
          <td style={{textAlign:'center', color:'#ffffff', width:30,borderRight:'1px solid #CCC'}}>{innerdata.SUP}</td>
          <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>{innerdata.US}</td>
          <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>{innerdata.RTN}</td>
          <td style={{textAlign:'center',width:30,borderRight:'1px solid #CCC'}}>{innerdata.SALE}</td>
          </tr>
          </table>
          </td>
  )

    
      })

      dataDiv.push(   <tr style={{borderTop:'1px solid #ccc'}}>{dataDivs}</tr>)
      

    }
    
    )



this.setState({headerDiv:headerDiv, dataDiv:dataDiv,loading:true})

    
    
      
          })
  


    
      .then(result => console.log(result))
      .catch(error => { console.log('error', error); this.setState({ loading: true }); });

  }
  handleChangeItems= (event) => 
  {
    
  
    this.setState({
      loading:false,
      Itemvalue:event.target.value
    })
    let Itemvalue=event.target.value

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Origin", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("CenterId",context.state.CenterId);
        urlencoded.append("from", formatDate(new Date(context.state.from), 'DD-MM-YYYY'));
        urlencoded.append("to", formatDate(new Date(context.state.to), 'DD-MM-YYYY'));
        urlencoded.append("Selling_Day", formatDate(new Date(), 'dddd'));
      //  alert(supply_date)
         
   
        // console.log(CenterId)
        // console.log(supply_date)
        var GETSALESBILLING = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        
        fetch(ApiConstants.GET_SupplyReport, GETSALESBILLING)
        .then(dataWrappedByPromise => dataWrappedByPromise.json())
        .then(CETERBOOKRES => 
          {
    
            var dateArray = [];
            var dateArraytable = [];
            let dateArraytabletr=[];
            let Total_supply=0
            let Totalamount=0;
let from=formatDate(new Date(context.state.from), 'DD-MM-YYYY');
let to=formatDate(new Date(context.state.to), 'DD-MM-YYYY');
            from=from.split('-')[2]+'-'+from.split('-')[1]+'-'+from.split('-')[0];
            to=to.split('-')[2]+'-'+to.split('-')[1]+'-'+to.split('-')[0];
            var currentDate = moment(from);
            var stopDate = moment(to);

        
           if(Itemvalue!=0)
           {
            while (currentDate <= stopDate) {
              let day=moment(currentDate).format('dddd') 
                dateArray.push( moment(currentDate).format('DD-MM-YYYY') )
                dateArray.push( moment(currentDate).format('dddd') )
let TotalSupply=0;let centerdata=[],centerdata1=[]
                CETERBOOKRES.CenterSupply.map(function(data)
                {  
                  if(data.ItemId==Itemvalue)
                  {
                  let date=new Date(data.Supply_date.split('-')[1]+'/'+data.Supply_date.split('-')[0]+'/'+data.Supply_date.split('-')[2])


                  if(new Date(date).getTime()==new Date(currentDate).getTime())
                  {
                 
                    let __addIt=parseFloat(data.TotalSuppy)
                    if(isNaN(__addIt)){__addIt=0}
                    TotalSupply= parseFloat(TotalSupply)+ __addIt
                    if(TotalSupply=="" || isNaN(parseFloat(TotalSupply))==true)
                    {
                      TotalSupply=0
                    }

                    centerdata.push(
                      <tr>
                      <td>{data.centername}</td>
                      </tr>)
                          centerdata1.push(
                            <tr> 
                           <td>{isNaN(parseFloat(data.TotalSuppy))==true?0:parseFloat(data.TotalSuppy)}</td> 
                            </tr>)
                  }
                 
                }
                })

                dateArray.push(TotalSupply)
let price=0;




CETERBOOKRES.Price.map(function(data)
{  
  
  if(data.Itemid==Itemvalue)
  {

                if(day=='Sunday')
                {
                  price=data.Sunday_Pure_Price
                }
                if(day=='Monday')
                {
                  price=data.Monday_Pure_Price
                }
                if(day=='Thursday')
                {
                  price=data.Thursday_Pure_Price
                }
                if(day=='Tuesday')
                {
                  price=data.Tuesday_Pure_Price
                }
                if(day=='Wednesday')
                {
                  price=data.Wednesday_Pure_Price
                }
                if(day=='Friday')
                {
                  price=data.Friday_Pure_Price
                }
                if(day=='Saturday')
                {
                  price=data.Saturday_Pure_Price
                }

            

           
              }
            })
            
              // _Pure_Price
          if(TotalSupply=="" || isNaN(parseFloat(TotalSupply))==true)
          {
            TotalSupply=0
          }
          if(price=="" || isNaN(parseFloat(price))==true)
          {
            price=0
          }
              Totalamount=parseFloat(Totalamount)+(parseFloat(TotalSupply)*parseFloat(price))
              Total_supply=parseFloat(Total_supply)+parseFloat(TotalSupply)
              dateArraytabletr.push(
              <tr> <th>{moment(currentDate).format('DD-MM-YYYY')}</th> <td>{moment(currentDate).format('dddd')}</td> 
              <td>{price}</td>  <td>{TotalSupply}</td>  <td>Rs.{parseFloat(parseFloat(TotalSupply)*parseFloat(price)).toFixed(2) }</td>
              </tr>)
              dateArraytabletr.push(
                <tr>
                  <td> </td><td>  </td>
                  <td> 
                <table style={{color: '#000'}} className="table table-info table-striped">
               {centerdata}
                </table></td>
                  <td> 
                <table style={{color: '#000'}}  className="table table-info table-striped">
               {centerdata1}
                </table></td>
                </tr>
                )

                currentDate = moment(currentDate).add(1, 'days');
          }
           }
          dateArraytable.push(
          <table  className="table table-dark table-striped">
  <thead>
    <tr>
      <th >Date</th>
      <th>Day</th>
      <th >Purchage Rate</th>
      <th >Supply Copies</th>
      <th >Amount</th>
    </tr>
  </thead>
  <tbody>
{dateArraytabletr}

<tr style={{ borderTop:'2px solid #fff'}}>
      <th ></th>
      <th></th>
      <th >Total</th>
      <th >{Total_supply}</th>
      <th >Rs.{parseFloat(Totalamount).toFixed(2)}</th>
    </tr>
  </tbody>
</table>
  
  )


          this.setState({dateArraytable:dateArraytable, loading:true,})
          
        
  })


} 

handleChangeItemsbysupply= (event) => 
{
  

  this.setState({
    loading:false,
    Itemvaluesupply:event.target.value
  })
  let Itemvaluesupply=event.target.value

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  myHeaders.append("Origin", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("CenterId",context.state.CenterId);
      urlencoded.append("from", formatDate(new Date(context.state.from), 'DD-MM-YYYY'));
      urlencoded.append("to", formatDate(new Date(context.state.to), 'DD-MM-YYYY'));
      urlencoded.append("Selling_Day", formatDate(new Date(), 'dddd'));
    //  alert(supply_date)
       
 
      // console.log(CenterId)
      // console.log(supply_date)
      var GETSALESBILLING = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      
      fetch(ApiConstants.GET_SupplyReport, GETSALESBILLING)
      .then(dataWrappedByPromise => dataWrappedByPromise.json())
      .then(CETERBOOKRES => 
        {
  
          var dateArray = [];
          var dateArraytable = [];
          let dateArraytabletr=[];
          let Total_supply=0
          let Totalamount=0;
let from=formatDate(new Date(context.state.from), 'DD-MM-YYYY');
let to=formatDate(new Date(context.state.to), 'DD-MM-YYYY');
          from=from.split('-')[2]+'-'+from.split('-')[1]+'-'+from.split('-')[0];
          to=to.split('-')[2]+'-'+to.split('-')[1]+'-'+to.split('-')[0];
          var currentDate = moment(from);
          var stopDate = moment(to);

      
         if(Itemvaluesupply!=0)
         {
          while (currentDate <= stopDate) {
            let day=moment(currentDate).format('dddd') 
              dateArray.push( moment(currentDate).format('DD-MM-YYYY') )
              dateArray.push( moment(currentDate).format('dddd') )
let TotalSupply=0;let centerdata=[],centerdata1=[]
              CETERBOOKRES.CenterSupply.map(function(data)
              {  
                if(data.ItemId==Itemvaluesupply)
                {
                let date=new Date(data.Supply_date.split('-')[1]+'/'+data.Supply_date.split('-')[0]+'/'+data.Supply_date.split('-')[2])


                if(new Date(date).getTime()==new Date(currentDate).getTime())
                {
               
                  let __addSup=parseFloat(data.TotalSuppy)
                  if(isNaN(__addSup)){__addSup=0}
                  TotalSupply= parseFloat(TotalSupply)+ __addSup
                  if(TotalSupply=="" || isNaN(parseFloat(TotalSupply))==true)
                  {
                    TotalSupply=0
                  }

                  centerdata.push(
                    <tr>
                    <td>{data.CenterId}</td>
                    </tr>)

                    let v=0;
                 

                    // console.log(v)
for(let c=0; c<context.state.Centers.length; c++)
{
  
  
                    if(context.state.Centers[c].id==data.CenterId)
                    {
             
                        centerdata1[c]={id:data.CenterId,  td:<td>{isNaN(parseFloat(data.TotalSuppy))==true?0:parseFloat(data.TotalSuppy)}</td>}
                   
                    }
            
                  //  console.log(context.state.Centers[c].Name)
                    
                  }

                  // if(v==0)
                  // {
                  //   centerdata1.push(
                    
                  //     <td>0</td> 
                  //    )
                  // }
                }
               
              }
              })

              dateArray.push(TotalSupply)
let price=0;


let centerdata12=[]

for(let c=0; c<context.state.Centers.length; c++)
{
  if(centerdata1[c]!=undefined)
  {
if(centerdata1[c].id==context.state.Centers[c].id)
{
  centerdata12.push(centerdata1[c].td)
}
else{
  centerdata12.push(<td>0</td> )
}
  }else{
    centerdata12.push(<td>0</td> )
  }
}

CETERBOOKRES.Price.map(function(data)
{  

if(data.Itemid==Itemvaluesupply)
{

              if(day=='Sunday')
              {
                price=data.Sunday_Pure_Price
              }
              if(day=='Monday')
              {
                price=data.Monday_Pure_Price
              }
              if(day=='Thursday')
              {
                price=data.Thursday_Pure_Price
              }
              if(day=='Tuesday')
              {
                price=data.Tuesday_Pure_Price
              }
              if(day=='Wednesday')
              {
                price=data.Wednesday_Pure_Price
              }
              if(day=='Friday')
              {
                price=data.Friday_Pure_Price
              }
              if(day=='Saturday')
              {
                price=data.Saturday_Pure_Price
              }

          

         
            }
          })
          
            // _Pure_Price
        if(TotalSupply=="" || isNaN(parseFloat(TotalSupply))==true)
        {
          TotalSupply=0
        }
        if(price=="" || isNaN(parseFloat(price))==true)
        {
          price=0
        }
            Totalamount=parseFloat(Totalamount)+(parseFloat(TotalSupply)*parseFloat(price))
            Total_supply=parseFloat(Total_supply)+parseFloat(TotalSupply)
            dateArraytabletr.push(
            <tr> <th>{moment(currentDate).format('DD-MM-YYYY')}</th> <td>{moment(currentDate).format('dddd')}</td> 
            <td>{price}</td>  
            
           
           
           {centerdata12}
           
      
            
            <td>{TotalSupply}</td>  <td>Rs.{parseFloat(parseFloat(TotalSupply)*parseFloat(price)).toFixed(2) }</td>
            
            
         
            
            </tr>)
            // dateArraytabletr.push(
            // //   <tr>
            // //     <td> </td><td>  </td>
            // //     <td> 
            // //   <table style={{color: '#000'}} className="table table-info table-striped">
            // //  {centerdata}
            // //   </table></td>
            // //     <td> 
            // //   <table style={{color: '#000'}}  className="table table-info table-striped">
            // //  {centerdata1}
            // //   </table></td>
            // //   </tr>
          
            //   )

              currentDate = moment(currentDate).add(1, 'days');
        }
         }

        let centerdatalist=[]
    context.state.Centers.map(function(Centers){
      centerdatalist.push(    <th >{Centers.Name}</th>)
         })


        dateArraytable.push(
          <div>
        <table  style={{fontSize:12, textAlign:'center', width:2000}} className="table table-striped">
<thead>
  <tr >
    <th style={{width:100}}>Date</th>
    <th>Day</th>
    <th >Purchage Rate</th>

  {centerdatalist}

    <th >Total Copies</th>
    <th >Amount</th>
  </tr>
</thead>
<tbody>
{dateArraytabletr}


</tbody>
</table>
<div style={{fontWeight:'bold', fontSize:14, }}>

  <span style={{margin:10, padding:10}}>
Total Supply Copies : { Total_supply}</span>

<span style={{margin:10, padding:10}}>
Total Amount : Rs.{parseFloat(Totalamount).toFixed(2)}</span>

</div></div>
)


        this.setState({dateArraytableItem:dateArraytable, loading:true,})
        
      
})


}
handleChangeVendor= (event) => 
{
  

  this.setState({
    loading:false,
    VendorId:event.target.value,
    valueVendor1:event.target.value
  })
  let VendorId=event.target.value

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  myHeaders.append("Origin", "application/x-www-form-urlencoded");

      var urlencoded = new URLSearchParams();
      urlencoded.append("VendorId",VendorId);
      urlencoded.append("Billing_Start_Date",  formatDate(new Date(this.state.from), 'DD-MM-YYYY')  );
      urlencoded.append("Billing_End_Date", formatDate(new Date(this.state.to), 'DD-MM-YYYY') );
    //  alert(supply_date)
       
 
      // console.log(CenterId)
      // console.log(supply_date)
      var GETSALESBILLING = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      


      
      fetch(ApiConstants.GETPaymentHistoryReport, GETSALESBILLING)
      .then(dataWrappedByPromise => dataWrappedByPromise.json())
      .then(PaymentHistory => 
        {
let Payment_history=[]
let Payment_history_data=[]
let Payment=PaymentHistory.response
let allAmt=0;
          console.log(PaymentHistory.response)

          Payment.sort((a, b) => {
              if(a.Billing_Date!=undefined)
              {
                          let  supply_dates1=a.Billing_Date.split('-')[1]+"/"+a.Billing_Date.split('-')[0]+"/"+a.Billing_Date.split('-')[2]
                          let  supply_dates2=b.Billing_Date.split('-')[1]+"/"+b.Billing_Date.split('-')[0]+"/"+b.Billing_Date.split('-')[2]
                          
                          return new Date(supply_dates1) - new Date(supply_dates2); // descending
              } }
              )
          Payment.map(function(Payment)
          {
         if(Payment.amount_paid!=0)
         {
          let __ap=parseFloat(Payment.amount_paid); if(isNaN(__ap)){__ap=0}
          allAmt=allAmt+__ap
          Payment_history_data.push(
           
            <tr key={Payment.id}> <th>{Payment.Billing_Date}</th> <td>{Payment.amount_paid}</td> 
            <td  style={{ fontSize:14}}>{context.paymentModeLabel(Payment.payment_type, Payment.payment_referece || Payment.payment_referece_1 || Payment.payment_id)}</td>  <td>{Payment.payment_id}</td>  <td >
              <div style={{ width:150, wordWrap:'break-word', fontSize:12}}>
              {Payment.billing_id}
              </div>
              </td></tr>)
         } 
        })
    Payment_history.push(
            <table  className="table table-dark table-striped">
    <thead>
      <tr>
        <th >Date</th>
        <th>Amount</th>
        <th >Mode</th>
        <th >Reference</th>
        <th >Payment id</th>
      
        <th ></th>
      </tr>
    </thead>
    <tbody>
  {Payment_history_data}
  
  <tr style={{ borderTop:'2px solid #fff'}}>
        <th >Total</th>
        <th>Rs.{parseFloat(allAmt).toFixed(2)}</th>
        <th ></th>
        <th ></th>
        <th ></th>
      </tr>
    </tbody>
  </table>
    
    )
    this.setState({
      dataDivPayments:Payment_history, loading:true,
    })

        })

      }


  printDiv() { 
    var divContents = document.getElementById("PrintDiv").innerHTML; 
    var a = window.open('', '', 'height=500, width=500'); 
    a.document.write('<html>'); 
    a.document.write('<body>'); 
    a.document.write(divContents); 
    a.document.write('</body></html>'); 
    a.document.close(); 
    a.print(); 
} 
PrintDivsupplys() { 
  var divContents = document.getElementById("PrintDivsupplys").innerHTML; 
  var a = window.open('', '', 'height=500, width=500'); 
  a.document.write('<html>'); 
  a.document.write('<body>'); 
  a.document.write(divContents); 
  a.document.write('</body></html>'); 
  a.document.close(); 
  a.print(); 
} 



printDivSupply() { 
  var divContents = document.getElementById("PrintDivSupply").innerHTML; 
  var a = window.open('', '', 'height=500, width=500'); 
  a.document.write('<html>'); 
  a.document.write('<body>'); 
  a.document.write(divContents); 
  a.document.write('</body></html>'); 
  a.document.close(); 
  a.print(); 
} 

PrintDivPayment() { 
  var divContents = document.getElementById("PrintDivPayment").innerHTML; 
  var a = window.open('', '', 'height=500, width=500'); 
  a.document.write('<html>'); 
  a.document.write('<body>'); 
  a.document.write(divContents); 
  a.document.write('</body></html>'); 
  a.document.close(); 
  a.print(); 
} 
PrintDivCenter() { 
  var divContents = document.getElementById("PrintDivCenter").innerHTML; 
  var a = window.open('', '', 'height=500, width=500'); 
  a.document.write('<html>'); 
  a.document.write('<body>'); 
  a.document.write(divContents); 
  a.document.write('</body></html>'); 
  a.document.close(); 
  a.print(); 
}

  handleDayChange=(selectedDay, modifiers, dayPickerInput)=> {
    var d = new Date(selectedDay);
      this.setState({supply_date:formatDate(new Date(selectedDay), 'DD-MM-YYYY')})
   // this.savetojson()
    this.GetData(this.state.CenterId, formatDate(new Date(selectedDay), 'DD-MM-YYYY'), this.state.VendorId);

  }
  // ================= Report 1 & Report 2 helpers =================
  parseAllJsonDate = (v) => {
    if (v == null) return [];
    if (typeof v === 'string') {
      try { return JSON.parse(v.replace('\\', '')); } catch (e) { return []; }
    }
    return v;
  }

  // Mon=0 ... Sun=6 from a DD-MM-YYYY string
  weekdayMonFirst = (ddmmyyyy) => {
    const p = String(ddmmyyyy).split('-');
    const d = new Date(p[2] + '-' + p[1] + '-' + p[0]);
    return (d.getDay() + 6) % 7;
  }

  // daily subscription copies [{date:'DD-MM-YYYY', copies}] + weekday commission CSV -> {rows,total}
  computeIncentiveDaily = (dailySeries, commissionCSV) => {
    const rates = String(commissionCSV || '').split(',').map(x => parseFloat(x) || 0);
    const names = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
    let total = 0; const rows = [];
    (dailySeries || []).forEach(day => {
      const copies = parseFloat(day.copies) || 0;
      const wd = this.weekdayMonFirst(day.date);
      const rate = rates[wd] || 0;
      const amount = copies * rate;
      total += amount;
      rows.push({ date: day.date, weekday: names[wd], copies, rate, amount });
    });
    return { rows, total };
  }

  catStyle = (cat) => {
    if (/incentive/i.test(cat || '')) return { color: '#b8860b', fontWeight: 700 };
    if (/subscription/i.test(cat || '')) return { color: '#2e7d32', fontStyle: 'italic' };
    return {};
  }

  // Human-readable payment type + reference: Cash / UPI: <id> / Cheque No: <no> / Bank: <ref>
  paymentModeLabel = (mode, ref) => {
    const m = String(mode || '').trim();
    const r = String(ref || '').trim();
    if (!m) return r ? ('-: ' + r) : '-';
    if (/cash/i.test(m)) return 'Cash';
    if (/cheque/i.test(m)) return r ? ('Cheque No: ' + r) : 'Cheque';
    if (/upi|phonepe|gpay|g-?pay|paytm|online/i.test(m)) return r ? (m + ': ' + r) : m;
    if (/bank|neft|imps|rtgs/i.test(m)) return r ? ('Bank: ' + r) : 'Bank';
    return r ? (m + ': ' + r) : m;
  }

  // group payment rows -> [{key,cash,bank,total,rows}]
  groupPayments = (rows, mode) => {
    const groups = {};
    (rows || []).forEach(r => {
      const bd = String(r.Billing_Date || '');
      let key = 'Unknown';
      if (mode === 'date') key = bd;
      else if (mode === 'month') { const p = bd.split('-'); key = (p[1] || '??') + '-' + (p[2] || '????'); }
      else if (mode === 'vendor') key = r.Vendor_Name || r.vendor_name || r.VendorId || 'Vendor';
      else if (mode === 'centre') key = r.Center_Name || r.CenterName || r.Center_id || r.CenterId || 'Centre';
      if (!groups[key]) groups[key] = { key, cash: 0, bank: 0, total: 0, rows: [] };
      const amt = parseFloat(r.amount_paid) || 0;
      const isBank = /bank|online|cheque/i.test(String(r.payment_type || ''));
      groups[key][isBank ? 'bank' : 'cash'] += amt;
      groups[key].total += amt;
      groups[key].rows.push(r);
    });
    return Object.keys(groups).map(k => groups[k]);
  }

  // list of 'DD-MM-YYYY' dates between two DD-MM-YYYY strings (inclusive)
  dayListInRange = (fromS, toS) => {
    const f = String(fromS).split('-'); const t = String(toS).split('-');
    let cur = moment(f[2] + '-' + f[1] + '-' + f[0]);
    const stop = moment(t[2] + '-' + t[1] + '-' + t[0]);
    const out = [];
    while (cur <= stop) { out.push(cur.format('DD-MM-YYYY')); cur = moment(cur).add(1, 'days'); }
    return out;
  }

  centreName = (centerId) => {
    const c = (this.state.Centers || []).find(x => String(x.id) === String(centerId));
    return c ? c.Name : (centerId ? ('Centre ' + centerId) : 'Centre');
  }

  // join subscription copies (per vendor+item) with weekday commission -> monthly incentive + daily rows
  computeIncentiveRows = (subs, comms, fromS, toS) => {
    const cidx = {};
    (comms || []).forEach(c => { cidx[String(c.vendor_id) + '|' + String(c.itemId)] = c; });
    // vendor id -> Name (from the VIEWCENTER_Item_Vendor catalog loaded in componentDidMount)
    const vNameById = {};
    (this.state.AllVendors || []).forEach(v => { vNameById[String(v.id)] = v.Name; });
    // per-item non-sales days (DD-MM-YYYY set) from the item catalog — excluded from incentive
    const nonSalesByItem = {};
    (this.state.Item || []).forEach(it => {
      nonSalesByItem[String(it.id)] = new Set(String(it.NonSalesDays || '').split(',').map(x => x.trim()).filter(Boolean));
    });
    const allDays = this.dayListInRange(fromS, toS);
    const rows = [];
    (subs || []).forEach(s => {
      const c = cidx[String(s.vendor_id) + '|' + String(s.itemId)];
      const copies = parseFloat(s.Subscriptionres) || 0;
      if (copies <= 0) return;
      const commissionCSV = c ? c.Commission : '';
      const skip = nonSalesByItem[String(s.itemId)] || new Set();
      const days = allDays.filter(d => !skip.has(d));
      const daily = this.computeIncentiveDaily(days.map(d => ({ date: d, copies })), commissionCSV);
      rows.push({
        vendor_id: s.vendor_id,
        vendor_name: (c && c.vendor_name) || vNameById[String(s.vendor_id)] || ('Vendor ' + s.vendor_id),
        itemId: s.itemId,
        pub: c ? c.pub : String(s.itemId),
        center_id: c ? c.center_id : '',
        copies,
        commissionCSV,
        monthlyIncentive: daily.total,
        dailyRows: daily.rows,
        excludedDays: allDays.length - days.length
      });
    });
    return rows;
  }

  // group incentive rows to match the payments grouping toggle
  groupIncentive = (rows, mode) => {
    if (mode === 'date') {
      const byDate = {};
      (rows || []).forEach(r => r.dailyRows.forEach(d => { byDate[d.date] = (byDate[d.date] || 0) + d.amount; }));
      return Object.keys(byDate).map(k => ({ key: k, total: byDate[k] }));
    }
    const keyOf = (r) => {
      if (mode === 'vendor') return r.vendor_name;
      if (mode === 'centre') return this.centreName(r.center_id);
      return 'Month total';
    };
    const g = {};
    (rows || []).forEach(r => { const k = keyOf(r); g[k] = (g[k] || 0) + r.monthlyIncentive; });
    return Object.keys(g).map(k => ({ key: k, total: g[k] }));
  }

  renderIncentive = () => {
    const rows = this.state.incentiveReportData;
    if (!rows || rows.length === 0) return null;
    const groups = this.groupIncentive(rows, this.state.paymentGroupBy);
    let total = 0; groups.forEach(g => total += g.total);
    const totalCopies = rows.reduce((a, r) => a + r.copies, 0);
    const anyExcluded = rows.some(r => (r.excludedDays || 0) > 0);
    return (
      <div style={{ marginTop: 22 }}>
        <h5 style={{ color: '#b8860b', fontWeight: 700 }}>Incentive / Subscription (computed on subscription copies)</h5>
        <table className="table table-striped" style={{ fontSize: 13, maxWidth: 600 }}>
          <thead>
            <tr style={{ background: '#001E41', color: '#fff' }}>
              <th>{this.state.paymentGroupBy === 'date' ? 'Date' : (this.state.paymentGroupBy === 'centre' ? 'Centre' : (this.state.paymentGroupBy === 'vendor' ? 'Vendor' : 'Period'))}</th>
              <th>Incentive (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            {groups.map((g, i) => (
              <tr key={i} style={{ color: '#b8860b', fontWeight: 600 }}>
                <td>{g.key}</td><td>Rs.{g.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr style={{ fontWeight: 700, borderTop: '2px solid #000' }}>
              <td>TOTAL INCENTIVE</td><td>Rs.{total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
        <div style={{ color: '#2e7d32', fontStyle: 'italic', fontSize: 12 }}>
          Total subscription copies (all vendors/items): {totalCopies}. Incentive = copies × per-day commission, summed over the selected date range{anyExcluded ? ', excluding each item’s non-sales days' : ''}.
        </div>
      </div>
    );
  }

  buildPaymentsReport = () => {
    this.setState({ loading: false, paymentsReportData: [], incentiveReportData: [] });
    var H = new Headers();
    H.append("Content-Type", "application/x-www-form-urlencoded");
    H.append("Origin", "application/x-www-form-urlencoded");
    const fromS = formatDate(new Date(this.state.from), 'DD-MM-YYYY');
    const toS = formatDate(new Date(this.state.to), 'DD-MM-YYYY');

    var pBody = new URLSearchParams();
    pBody.append("VendorId", this.state.VendorId || "");
    pBody.append("CenterId", this.state.CenterId || "");
    pBody.append("Billing_Start_Date", fromS);
    pBody.append("Billing_End_Date", toS);

    const payments = fetch(ApiConstants.GETPaymentHistoryReport, { method: 'POST', headers: H, body: pBody, redirect: 'follow' }).then(r => r.json()).catch(() => ({ response: [] }));
    const comms = fetch('https://meeranewsagency.cannytechnology.com/api/UserRoutermobile/GetsubscribeCommissionAll', { method: 'POST', headers: H, body: new URLSearchParams(), redirect: 'follow' }).then(r => r.json()).catch(() => ({ response: [] }));
    const subs = fetch(ApiConstants.subscribebyCenter_id, { method: 'POST', headers: H, body: new URLSearchParams(), redirect: 'follow' }).then(r => r.json()).catch(() => ({ response: [] }));

    Promise.all([payments, comms, subs]).then(([pr, cr, sr]) => {
      const prows = (pr && pr.response) ? pr.response : [];
      const crows = (cr && cr.response) ? cr.response : [];
      const srows = (sr && sr.response) ? sr.response : [];
      const groups = this.groupPayments(prows, this.state.paymentGroupBy);
      const incentiveRows = this.computeIncentiveRows(srows, crows, fromS, toS);
      this.setState({ paymentsReportData: groups, incentiveReportData: incentiveRows, loading: true });
    }).catch(() => this.setState({ paymentsReportData: [], incentiveReportData: [], loading: true }));
  }

  renderPaymentsReport = () => {
    let gc = 0, gb = 0, gt = 0;
    const blocks = this.state.paymentsReportData.map((g, gi) => {
      gc += g.cash; gb += g.bank; gt += g.total;
      return (
        <div key={gi} style={{ marginBottom: 14 }}>
          <table className="table table-striped" style={{ fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#001E41', color: '#fff' }}><th colSpan={4}>{g.key}</th></tr>
              <tr><th>Date</th><th>Cash</th><th>Bank</th><th>Type / Ref</th></tr>
            </thead>
            <tbody>
              {g.rows.map((r, i) => {
                const isBank = /bank|online|cheque/i.test(String(r.payment_type || ''));
                const amt = (parseFloat(r.amount_paid) || 0).toFixed(2);
                return (
                  <tr key={i} style={this.catStyle(r.category || r.type)}>
                    <td>{r.Billing_Date}</td>
                    <td>{isBank ? '' : amt}</td>
                    <td>{isBank ? amt : ''}</td>
                    <td>{this.paymentModeLabel(r.payment_type, r.payment_referece || r.payment_referece_1 || r.payment_id)}</td>
                  </tr>
                );
              })}
              <tr style={{ fontWeight: 700, borderTop: '2px solid #000' }}>
                <td>Subtotal</td><td>Rs.{g.cash.toFixed(2)}</td><td>Rs.{g.bank.toFixed(2)}</td><td>Rs.{g.total.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    });
    return (
      <div>
        {blocks}
        <table className="table" style={{ fontSize: 14 }}>
          <tbody>
            <tr style={{ fontWeight: 700, background: '#e9ecef' }}>
              <td>GRAND TOTAL</td><td>Cash Rs.{gc.toFixed(2)}</td><td>Bank Rs.{gb.toFixed(2)}</td><td>Total Rs.{gt.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  // Report 2: aggregate supply/unsold/return/net-sale (+cost) by centre or item.
  // Spine = SupplyCenter (has CenterId + ItemId + TotalSuppy + UnsoldCopies).
  // Returns come from CenterBook transactions, attributable only per item (no CenterId there).
  aggregateStatement = (centerBook, supplyCenter, axis) => {
    const items = this.state.Item || [];
    const centers = this.state.Centers || [];
    const itemMap = {};
    items.forEach(it => { itemMap[String(it.id)] = { name: it.FormalName || it.name, rate: parseFloat(it.Price) || 0 }; });
    const centerMap = {};
    centers.forEach(c => { centerMap[String(c.id)] = c.Name; });

    // vendor -> centre map (to attribute Center Book subscription per centre)
    const vmap = {};
    (this.state.AllVendors || []).forEach(v => { vmap[String(v.id)] = String(v.CenterId); });

    // From CenterBook transactions: returns per item, and SUBSCRIPTION per axis-key (Center Book source)
    const returnByItem = {};
    const subsByKey = {};
    (centerBook || []).forEach(row => {
      const entries = this.parseAllJsonDate(row.All_JSON_Date);
      (entries || []).forEach(entry => {
        const centreId = vmap[String(entry.Vendor_Code)] || 'unknown';
        const txns = (entry && entry.transaction) ? entry.transaction : [];
        txns.forEach(t => {
          const id = String(t.id);
          returnByItem[id] = (returnByItem[id] || 0) + (parseFloat(t.Return_Copies) || 0);
          const sub = parseFloat(t.Subscription_Copies) || 0;
          if (sub) {
            const key = axis === 'item' ? id : centreId;
            subsByKey[key] = (subsByKey[key] || 0) + sub;
          }
        });
      });
    });

    // cells: axisKey -> itemId -> {supply,unsold,return} (supply/unsold from SupplyCenter)
    const cells = {};
    const touch = (ak, id) => {
      if (!cells[ak]) cells[ak] = {};
      if (!cells[ak][id]) cells[ak][id] = { supply: 0, unsold: 0, return: 0 };
      return cells[ak][id];
    };
    (supplyCenter || []).forEach(sc => {
      const id = String(sc.ItemId);
      const ak = axis === 'item' ? id : String(sc.CenterId);
      const c = touch(ak, id);
      c.supply += parseFloat(sc.TotalSuppy) || 0;
      c.unsold += parseFloat(sc.UnsoldCopies) || 0;
    });
    // returns are only item-attributable -> apply on item axis only
    if (axis === 'item') {
      Object.keys(cells).forEach(ak => Object.keys(cells[ak]).forEach(id => { cells[ak][id].return = returnByItem[id] || 0; }));
    }
    // include axis-keys that have subscription but no supply row
    Object.keys(subsByKey).forEach(ak => { if (!cells[ak]) cells[ak] = {}; });

    return Object.keys(cells).map(ak => {
      let supply = 0, unsold = 0, ret = 0, net = 0, cost = 0;
      Object.keys(cells[ak]).forEach(id => {
        const c = cells[ak][id];
        const rate = (itemMap[id] && itemMap[id].rate) || 0;
        const n = c.supply - c.return - c.unsold;
        supply += c.supply; unsold += c.unsold; ret += c.return; net += n; cost += n * rate;
      });
      const subscription = subsByKey[ak] || 0;
      const name = axis === 'item' ? ((itemMap[ak] && itemMap[ak].name) || ak) : (centerMap[ak] || (ak === 'unknown' ? 'Unmapped vendors' : 'Centre ' + ak));
      return { key: ak, name, supply, unsold, return: ret, net, cost, subscription };
    }).sort((a, b) => b.net - a.net);
  }

  GetMonthlyStatement = () => {
    this.setState({ loading: false, monthlyStatementData: [] });
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Origin", "application/x-www-form-urlencoded");
    var urlencoded = new URLSearchParams();
    urlencoded.append("from", formatDate(new Date(this.state.from), 'DD-MM-YYYY'));
    urlencoded.append("to", formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
    urlencoded.append("Billing_date_mode", "2");
    fetch(ApiConstants.GETSALEFORREPORTALLCENTER, { method: 'POST', headers: myHeaders, body: urlencoded, redirect: 'follow' })
      .then(r => r.json())
      .then(res => {
        const centerBook = (res && res.CenterBook) ? res.CenterBook : [];
        const supplyCenter = (res && res.SupplyCenter) ? res.SupplyCenter : [];
        const data = this.aggregateStatement(centerBook, supplyCenter, this.state.statementAxis);
        this.setState({ monthlyStatementData: data, loading: true });
      })
      .catch(() => this.setState({ monthlyStatementData: [], loading: true }));
  }

  renderStatement = () => {
    const isItem = this.state.statementAxis === 'item';
    let ts = 0, tr = 0, tu = 0, tn = 0, tc = 0, tsub = 0;
    const rows = this.state.monthlyStatementData.map((b, i) => {
      ts += b.supply; tr += b.return; tu += b.unsold; tn += b.net; tc += b.cost; tsub += (b.subscription || 0);
      return (
        <tr key={i}>
          <td style={{ textAlign: 'left' }}>{b.name || b.key}</td>
          <td>{b.supply}</td><td>{b.unsold}</td><td>{isItem ? b.return : '—'}</td>
          <td style={{ color: '#2e7d32' }}>{b.subscription || 0}</td>
          <td>{b.net}</td>
          <td>Rs.{(b.cost || 0).toFixed(2)}</td>
        </tr>
      );
    });
    return (
      <div>
        <table className="table table-striped" style={{ fontSize: 13, textAlign: 'center' }}>
          <thead>
            <tr style={{ background: '#001E41', color: '#fff' }}>
              <th style={{ textAlign: 'left' }}>{isItem ? 'Item' : 'Centre'}</th>
              <th>Supply</th><th>Unsold</th><th>Return</th><th>Subscription</th><th>Net Sale</th><th>Net Sale (Cost)</th>
            </tr>
          </thead>
          <tbody>
            {rows}
            <tr style={{ fontWeight: 700, borderTop: '2px solid #000' }}>
              <td style={{ textAlign: 'left' }}>TOTAL</td>
              <td>{ts}</td><td>{tu}</td><td>{isItem ? tr : '—'}</td>
              <td style={{ color: '#2e7d32' }}>{tsub}</td>
              <td>{tn}</td><td>Rs.{tc.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
        {!isItem &&
          <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
            Note: per-centre Returns are not provided by this endpoint (returns are only item-level).
            Net Sale here = Supply − Unsold. Switch to Item wise for return figures.
          </div>}
      </div>
    );
  }

  PrintDivPaymentsReport = () => {
    const el = document.getElementById("PrintDivPaymentsReport");
    if (!el) return;
    const w = window.open('', '', 'height=600, width=900');
    w.document.write('<html><head><title>Payments Report</title></head><body>');
    w.document.write(el.innerHTML);
    w.document.write('</body></html>');
    w.document.close(); w.print();
  }

  PrintDivStatement = () => {
    const el = document.getElementById("PrintDivStatement");
    if (!el) return;
    const w = window.open('', '', 'height=600, width=900');
    w.document.write('<html><head><title>Monthly Statement</title></head><body>');
    w.document.write(el.innerHTML);
    w.document.write('</body></html>');
    w.document.close(); w.print();
  }

  // Centre-wise Sales/Collection report: billed (Total) vs collected (Amount_Paid), split by payment type.
  // Single fetch (GETSALEFORREPORTALLCENTER); vendor->centre via AllVendors.
  GetSalesReportCentre = () => {
    this.setState({ loading: false, salesReportData: [], salesReportModes: [] });
    var H = new Headers();
    H.append("Content-Type", "application/x-www-form-urlencoded");
    H.append("Origin", "application/x-www-form-urlencoded");
    var body = new URLSearchParams();
    body.append("from", formatDate(new Date(this.state.from), 'DD-MM-YYYY'));
    body.append("to", formatDate(new Date(this.state.to), 'DD-MM-YYYY'));
    body.append("Billing_date_mode", "2");
    fetch(ApiConstants.GETSALEFORREPORTALLCENTER, { method: 'POST', headers: H, body, redirect: 'follow' })
      .then(r => r.json())
      .then(res => {
        const centerBook = (res && res.CenterBook) ? res.CenterBook : [];
        const vmap = {};
        (this.state.AllVendors || []).forEach(v => { vmap[String(v.id)] = String(v.CenterId); });
        const centerName = {};
        (this.state.Centers || []).forEach(c => { centerName[String(c.id)] = c.Name; });
        const buckets = {}, modeSet = {};
        centerBook.forEach(row => {
          const entries = this.parseAllJsonDate(row.All_JSON_Date);
          (entries || []).forEach(e => {
            const cid = vmap[String(e.Vendor_Code)] || 'unknown';
            if (!buckets[cid]) buckets[cid] = { billed: 0, collected: 0, byMode: {} };
            buckets[cid].billed += parseFloat(e.Total) || 0;
            const paid = parseFloat(e.Amount_Paid) || 0;
            buckets[cid].collected += paid;
            if (paid) {
              const mode = String(e.Paid_Source || 'Cash').trim() || 'Cash';
              buckets[cid].byMode[mode] = (buckets[cid].byMode[mode] || 0) + paid;
              modeSet[mode] = true;
            }
          });
        });
        const modes = Object.keys(modeSet).sort();
        const data = Object.keys(buckets).map(cid => {
          const b = buckets[cid];
          return {
            key: cid,
            name: centerName[cid] || (cid === 'unknown' ? 'Unmapped vendors' : 'Centre ' + cid),
            billed: b.billed, collected: b.collected, byMode: b.byMode, balance: b.billed - b.collected
          };
        }).sort((a, b) => b.billed - a.billed);
        this.setState({ salesReportData: data, salesReportModes: modes, loading: true });
      })
      .catch(() => this.setState({ salesReportData: [], salesReportModes: [], loading: true }));
  }

  renderSalesReportCentre = () => {
    const modes = this.state.salesReportModes;
    let tb = 0, tc = 0, tbal = 0; const tMode = {};
    const rows = this.state.salesReportData.map((r, i) => {
      tb += r.billed; tc += r.collected; tbal += r.balance;
      modes.forEach(m => { tMode[m] = (tMode[m] || 0) + (r.byMode[m] || 0); });
      return (
        <tr key={i}>
          <td style={{ textAlign: 'left' }}>{r.name}</td>
          <td>Rs.{r.billed.toFixed(2)}</td>
          {modes.map(m => <td key={m} style={{ color: '#2e7d32' }}>Rs.{(r.byMode[m] || 0).toFixed(2)}</td>)}
          <td style={{ fontWeight: 600 }}>Rs.{r.collected.toFixed(2)}</td>
          <td style={{ color: r.balance > 0 ? '#b00020' : '#2e7d32' }}>Rs.{r.balance.toFixed(2)}</td>
        </tr>
      );
    });
    return (
      <table className="table table-striped" style={{ fontSize: 13, textAlign: 'center' }}>
        <thead>
          <tr style={{ background: '#001E41', color: '#fff' }}>
            <th style={{ textAlign: 'left' }}>Centre</th>
            <th>Sales (Billed)</th>
            {modes.map(m => <th key={m}>{m}</th>)}
            <th>Total Collected</th><th>Balance</th>
          </tr>
        </thead>
        <tbody>
          {rows}
          <tr style={{ fontWeight: 700, borderTop: '2px solid #000' }}>
            <td style={{ textAlign: 'left' }}>TOTAL</td>
            <td>Rs.{tb.toFixed(2)}</td>
            {modes.map(m => <td key={m}>Rs.{(tMode[m] || 0).toFixed(2)}</td>)}
            <td>Rs.{tc.toFixed(2)}</td><td>Rs.{tbal.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>
    );
  }

  PrintDivCentreSales = () => {
    const el = document.getElementById("PrintDivCentreSales");
    if (!el) return;
    const w = window.open('', '', 'height=600, width=900');
    w.document.write('<html><head><title>Centre Sales</title></head><body>');
    w.document.write(el.innerHTML);
    w.document.write('</body></html>');
    w.document.close(); w.print();
  }

    render() {
      const { from, to } = this.state;
      const modifiers = { start: from, end: to };
      let Options = this.state.Centers.map(v => (
        <option key={v.id} value={v.id}>{v.Name}</option>
      ));
      let OptionsItem=[]
      if(this.state.Item.length>0)
      {
       OptionsItem = this.state.Item.map(v => (
        <option key={v.id} value={v.id}>{v.FormalName}</option>
      ));
       }

       let OptionsVendor=[]
       if(this.state.Vendor.length>0)
       {
        OptionsVendor = this.state.Vendor.map(v => (
         <option key={v.id} value={v.id}>{v.Name}</option>
       ));
        }
        return (
      <div>


        
           <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
    <h1 className="h3 mb-0 text-gray-800">Reports</h1>
   {/*Sidebar Toggle (Topbar)*/}
  <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
    <i className="fa fa-bars"></i>
  </button>

   {/*Topbar Search*/}
   <div className="d-sm-flex align-items-left justify-content-left mb-4">
         




    
         <div style={{marginTop: 24, marginLeft:30}} className="InputFromTo">


           <div>  <Helmet>
                        <style>{`

.DayPicker-Day{
  color: #333;
}
.DayPicker-Day--today
{
  color:red
}

          .DayPicker-Day--birthday {
            background-color: #00bcd4;
            color: white;
          }
          .DayPicker-Day--monday {
            color: #00bcd4;
          }
          .DayPicker-Caption{
            color: #333;
          }
          
          
          `}</style>
                      </Helmet>
       
        <DayPickerInput
          value={from}
          placeholder="From"
          format="LL"
          formatDate={formatDate}
          parseDate={parseDate}
          dayPickerProps={{
            selectedDays: [from, { from, to }],
           
            toMonth: to,
            modifiers,
            numberOfMonths: 2,
            onDayClick: () => this.to.getInput().focus(),
          }}
          onDayChange={this.handleFromChange}
        />{' '}
        —{' '}
        <span className="InputFromTo-to">
          <DayPickerInput
            ref={el => (this.to = el)}
            value={to}
            placeholder="To"
            format="LL"
            formatDate={formatDate}
            parseDate={parseDate}
            dayPickerProps={{
              selectedDays: [from, { from, to }],
              
              modifiers,
              month: from,
              fromMonth: from,
              numberOfMonths: 2,
            }}
            onDayChange={this.handleToChange}
          />
        </span>
     
      </div></div>
   
  
</div>

   {/*Topbar Navbar*/}
  <ul className="navbar-nav ml-auto">

      <div className="topbar-divider d-none d-sm-block"></div>

     {/*Nav Item - User Information*/}
    <li  onClick={this.logout}

    
    className="nav-item dropdown no-arrow">
      <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span className="mr-2 d-none d-lg-inline text-gray-600 small">Logout</span>
            </a>
       {/*Dropdown - User Information*/}
          </li>

  </ul>

</nav>
             <div className="container-fluid">

         
            

<div >
   

{
   this.state.from!=undefined && this.state.to!=undefined?
       <div id="harish" className="row">

<Tabs defaultActiveKey="SupplyByVendor" id="uncontrolled-tab-example" className="mb-3">
  

 
  <Tab eventKey="SupplyByVendor" title="Sales Report">
 
  <div style={{padding:0,overflow:'auto', maxWidth:'36%'}}>

{/*Project Card Example*/}
<div className="card shadow" style={{ width:3000,}}>

 <div className="card-body" >

 {this.state.Centers.length>0?   <div >
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Center:</label>
   <select  id="CentersSel2" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.value2} className="form-control" onChange={(event) =>{
   this.VendorbyCenter(event.target.value)
     this.setState({CenterId:event.target.value, Total_transactions_Sales:[], value2:event.target.value,})}}>
        <option value='0'>Select Center</option>    {Options}
        </select> 

</div>:null}

{this.state.Vendor.length>0?   <div >
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Vendor:</label>
   <select  id="CentersSelVendor" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.valueVendor} className="form-control" onChange={(event) => 
{
  this.setState({valueVendor:event.target.value})
  this.GetDatawillallsupply(this.state.CenterId,this.state.from,this.state.to, event.target.value)
  
}}>
        <option value='0'>Select Vendor</option>   {OptionsVendor}
        </select> 

</div>:null}


<div style={{clear:'both', float:'none'}}></div>

{
          this.state.loading?
          <div >
{this.state.Total_transactions_Sales.length>0?
  <div  id="PrintDivSupply" className="card-body">
  Sales Detail
<div  style={{fontSize:11, width:1200, overflow:'auto'}}>


<BootstrapTable keyField='id' style={"font-size:11"} data={ this.state.Total_transactions_Sales } columns={ this.state.columns } />

 
 
</div><hr/>

<div>

Return Detail
<div  style={{fontSize:11,width:1200, overflow:'auto'}}>


<BootstrapTable keyField='id' style={"font-size:11"} data={ this.state.Total_transactions_Return } columns={ this.state.columns } />



</div>


</div>



</div>
    :null}
{this.state.Total_transactions.length>0?
<button style={{    margin: 5,
marginLeft: 500}} onClick={this.printDivSupply}>Print It</button>
    :null}

</div>
:<div  className="loader" style={{marginLeft:'15%'}}>

</div>}
</div>

</div>

{/*Color System*/}

</div>    

  </Tab>
  <Tab eventKey="Payment" title="Payment History">
  <div style={{padding:0,overflow:'auto', maxWidth:'80%'}}>

{/*Project Card Example*/}
<div className="card shadow" style={{ width:1200,}}>

 <div className="card-body" >
 {this.state.Centers.length>0?   <div >
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Center:</label>
   <select  id="CentersSel1" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.value1} className="form-control" onChange={(event) =>{
   this.VendorbyCenter(event.target.value)
     this.setState({CenterId:event.target.value,  value1:event.target.value,})}}>
        <option value='0'>Select Center</option>    {Options}
        </select> 

</div>:null}
 {this.state.Vendor.length>0?   <div className="form-group">
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Vendor:</label>
   <select  id="CentersSel" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.valueVendor1} className="form-control"  onChange={this.handleChangeVendor}>
        <option value='0'>Select Vendor</option>   {OptionsVendor}
        </select> 

</div>:null}

<div style={{clear:'both', float:'none'}}></div>

{
          this.state.loading?
          <div>
          <div id="PrintDivPayment" >
 
{this.state.dataDivPayments}

 </div>
 <button style={{    margin: 5,
  marginLeft: 500}} onClick={this.PrintDivPayment}>Print It</button>
     </div>
:<div  className="loader" style={{marginLeft:'15%'}}>

</div>}
</div>

</div>

{/*Color System*/}

</div>  
  </Tab>

  <Tab eventKey="Item" title="Item Report">
  <div style={{padding:0,overflow:'auto'}}>

{/*Project Card Example*/}
<div className="card shadow" style={{ width:1000, overflow:'auto'}}>

 <div className="card-body" >
 <div  >
 {this.state.Centers.length>0?   <div className="form-group">
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Item:</label>
   <select  id="CentersSelOptionsItem" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.Itemvalue} className="form-control"  onChange={this.handleChangeItems}>
        <option value='0'>Select Item</option>    {OptionsItem}
        </select> 

</div>:null}

<div style={{clear:'both', float:'none'}}></div>

{
          this.state.loading?
          <div>
<div id="PrintDiv">
  {this.state.dateArraytable}
  </div>
{this.state.dateArraytable.length>0?
  <button style={{    margin: 5,
marginLeft: 500}} onClick={this.printDiv}>Print It</button>
  
    :null}
  </div>
:<div  className="loader">
  
</div>}
</div>
 </div>
</div>

{/*Color System*/}

</div>   

  </Tab>
  
  
  <Tab eventKey="Center" title="Center Report">
  <div style={{padding:0,overflow:'auto', maxWidth:'36%'}}>

{/*Project Card Example*/}
<div className="card shadow" style={{ width:3000,}}>

 <div className="card-body" >

 {this.state.Centers.length>0?   <div className="form-group">
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Center:</label>
   <select  id="CentersSel" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.value} className="form-control"  onChange={this.handleChange}>
        <option value='0'>Select Centers</option>  <option value='1'>ALL Centers</option>  {Options}
        </select> 

</div>:null}



<div style={{clear:'both', float:'none'}}></div>

{
          this.state.loading?<div>
          <div id="PrintDivCenter" >
 <table  style={{textAlign:'center',backgroundColor:'#001E41', color:'#ffffff', fontSize:12, fontWeight:600, padding:0, margin:0, border:'1px solid #CCC'}} >


{this.state.dataDiv}

</table> </div>

<button style={{    margin: 5,
  marginLeft: 500}} onClick={this.PrintDivCenter}>Print It</button>
     </div>

:<div  className="loader" style={{marginLeft:'15%'}}>

</div>}
</div>

</div>

{/*Color System*/}

</div>  

  {/* <button style={{    margin: 5,
marginLeft: 500}} onClick={this.printDiv}>Print It</button> */}

  </Tab>
 <Tab eventKey="Supply" title="Supply Report">
  <div style={{padding:0,overflow:'auto'}}>

{/*Project Card Example*/}
<div className="card shadow" style={{ width:1000, overflow:'auto'}}>

 <div className="card-body" >
 <div  >
 {this.state.Centers.length>0?   <div className="form-group">
  <label style={{float:'left', padding:' 5px '}} htmlFor="sel1">Item:</label>
   <select  id="CentersSelOptionsItemSupply" style={{padding:' 5px 10px', float:'left',height:'auto',  width: 'auto',}}  value={this.state.Itemvaluesupply} className="form-control"  onChange={this.handleChangeItemsbysupply}>
        <option value='0'>Select Item</option>    {OptionsItem}
        </select> 

</div>:null}

<div style={{clear:'both', float:'none'}}></div>

{
          this.state.loading?
          <div>
<div id="PrintDivsupplys">
  {this.state.dateArraytableItem}
  </div>
{this.state.dateArraytableItem.length>0?
  <button style={{    margin: 5,
marginLeft: 500}} onClick={this.PrintDivsupplys}>Print It</button>
  
    :null}
  </div>
:<div  className="loader">
  
</div>}
</div>
 </div>
</div>

{/*Color System*/}

</div>   

  </Tab>
  

  <Tab eventKey="PaymentsReport" title="Payments Report">
    <div style={{ padding: 0, overflow: 'auto' }}>
      <div className="card shadow" style={{ width: 1200 }}>
        <div className="card-body">
          <div style={{ marginBottom: 10 }}>
            <b style={{ marginRight: 10 }}>Group by:</b>
            {['date', 'month', 'centre', 'vendor'].map(m => (
              <button key={m}
                onClick={() => this.setState({ paymentGroupBy: m }, this.buildPaymentsReport)}
                style={{
                  marginRight: 6, padding: '4px 10px', textTransform: 'capitalize',
                  background: this.state.paymentGroupBy === m ? '#001E41' : '#e9ecef',
                  color: this.state.paymentGroupBy === m ? '#fff' : '#000',
                  border: '1px solid #ccc', borderRadius: 4
                }}>{m} wise</button>
            ))}
            <button onClick={this.buildPaymentsReport} style={{ marginLeft: 10, padding: '4px 10px' }}>Load</button>
          </div>
          <div style={{ marginBottom: 8, fontSize: 12 }}>
            <span style={{ marginRight: 14 }}><span style={{ display: 'inline-block', width: 12, height: 12, background: '#b8860b', marginRight: 4, verticalAlign: 'middle' }}></span>Incentive</span>
            <span><span style={{ display: 'inline-block', width: 12, height: 12, background: '#2e7d32', marginRight: 4, verticalAlign: 'middle' }}></span>Subscription</span>
          </div>
          {this.state.loading ?
            <div id="PrintDivPaymentsReport">
              {this.state.paymentsReportData.length > 0 ? this.renderPaymentsReport()
                : <div style={{ color: '#888' }}>No cash/bank payment rows for this range (payments are vendor-scoped). Click Load.</div>}
              {this.renderIncentive()}
            </div>
            : <div className="loader" style={{ marginLeft: '15%' }}></div>}
          <button style={{ margin: 5 }} onClick={this.PrintDivPaymentsReport}>Print It</button>
        </div>
      </div>
    </div>
  </Tab>

  <Tab eventKey="MonthlyStatement" title="Monthly Statement">
    <div style={{ padding: 0, overflow: 'auto' }}>
      <div className="card shadow" style={{ width: 1200 }}>
        <div className="card-body">
          <div style={{ marginBottom: 10 }}>
            <b style={{ marginRight: 10 }}>View:</b>
            {[['centre', 'Centre wise (Cost)'], ['item', 'Item wise (All Centres)']].map(pair => (
              <button key={pair[0]}
                onClick={() => this.setState({ statementAxis: pair[0] }, this.GetMonthlyStatement)}
                style={{
                  marginRight: 6, padding: '4px 10px',
                  background: this.state.statementAxis === pair[0] ? '#001E41' : '#e9ecef',
                  color: this.state.statementAxis === pair[0] ? '#fff' : '#000',
                  border: '1px solid #ccc', borderRadius: 4
                }}>{pair[1]}</button>
            ))}
            <button onClick={this.GetMonthlyStatement} style={{ marginLeft: 10, padding: '4px 10px' }}>Load</button>
          </div>
          {this.state.loading ?
            <div id="PrintDivStatement">
              {this.state.monthlyStatementData.length > 0 ? this.renderStatement()
                : <div style={{ color: '#888' }}>No data for this range. Click Load.</div>}
            </div>
            : <div className="loader" style={{ marginLeft: '15%' }}></div>}
          <button style={{ margin: 5 }} onClick={this.PrintDivStatement}>Print It</button>
        </div>
      </div>
    </div>
  </Tab>

  <Tab eventKey="CentreSales" title="Sales (Centre)">
    <div style={{ padding: 0, overflow: 'auto' }}>
      <div className="card shadow" style={{ width: 1200 }}>
        <div className="card-body">
          <div style={{ marginBottom: 10 }}>
            <button onClick={this.GetSalesReportCentre} style={{ padding: '4px 12px' }}>Load Centre Sales</button>
            <span style={{ marginLeft: 12, fontSize: 12, color: '#888' }}>Billed vs Collected per centre, split by payment type (Cash / UPI / Cheque / Bank).</span>
          </div>
          {this.state.loading ?
            <div id="PrintDivCentreSales">
              {this.state.salesReportData.length > 0 ? this.renderSalesReportCentre()
                : <div style={{ color: '#888' }}>Click "Load Centre Sales".</div>}
            </div>
            : <div className="loader" style={{ marginLeft: '15%' }}></div>}
          <button style={{ margin: 5 }} onClick={this.PrintDivCentreSales}>Print It</button>
        </div>
      </div>
    </div>
  </Tab>

</Tabs>


</div>:<div style={{color:'red', fontWeight:'500', fontSize:20, textAlign:'center'}}>Select From date and To date for getting Reports!</div>
}

</div>


    
                 </div>
        
           </div>

        )}
    
        }
      
